<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
  >
    <g>
      <linearGradient
        id="SVGID1"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="2.5"
        x2="100%"
        y2="2.5"
      >
        <stop
          offset="0"
          :class="$style.stop0"
        />

        <stop
          offset="0"
          :class="$style.stop1"
        >
          <animate
            attributeName="offset"
            dur="3000ms"
            from="0"
            to="0.8"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="0.1"
          :class="$style.stop2"
        >
          <animate
            attributeName="offset"
            dur="3000ms"
            from="0.1"
            to="0.9"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="0.2"
          :class="$style.stop3"
        >
          <animate
            attributeName="offset"
            dur="3000ms"
            from="0.2"
            to="1"
            repeatCount="indefinite"
          />
        </stop>
        <stop
          offset="1"
          :class="$style.stop4"
        />
      </linearGradient>
      <rect
        width="100%"
        height="30"
        fill="url(#SVGID1)"
      />
    </g>
  </svg>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'LoadAnimation'
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';

.stop0 {
  stop-color: lighten(map-get($colors, 'new-blue'), 30%);
}
.stop1 {
  stop-color: lighten(map-get($colors, 'new-blue'), 20%);
}
.stop2 {
  stop-color: lighten(map-get($colors, 'new-blue'), 15%);
}
.stop3 {
  stop-color: lighten(map-get($colors, 'new-blue'), 20%);
}
.stop4 {
  stop-color: lighten(map-get($colors, 'new-blue'), 30%);
}
</style>
